import { render } from "./MetaSection.vue?vue&type=template&id=799787b6&scoped=true"
import script from "./MetaSection.vue?vue&type=script&lang=js"
export * from "./MetaSection.vue?vue&type=script&lang=js"

import "./MetaSection.vue?vue&type=style&index=0&id=799787b6&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-799787b6"]])

export default __exports__